import { useFetch } from '@/shared/hooks/useFetch';
import { useMutate } from '@/shared/hooks/useMutate';
import { queryKeys } from '@/shared/api/queryKeys';
import {
  apiChargeMarkPaid,
  apiChargeMarkUnpaid,
  apiChargesList,
} from '@/entities/charges/modules/api/charges';
import type { ApiChargesListParams } from '@/shared/types/api/charges';

export const useCharges = (params: ApiChargesListParams) =>
  useFetch({
    api: () => apiChargesList(params),
    keywords: queryKeys.charges.list(params),
    staleTime: 30_000,
  });

export const useMarkChargePaid = () =>
  useMutate({
    api: (id: number) => apiChargeMarkPaid(id),
    invalidateKeys: [queryKeys.charges.all, queryKeys.cargoIds.all],
  });

export const useMarkChargeUnpaid = () =>
  useMutate({
    api: (id: number) => apiChargeMarkUnpaid(id),
    invalidateKeys: [queryKeys.charges.all, queryKeys.cargoIds.all],
  });
